import React from "react";
import T from "prop-types";
import Icon from "../Icon";

export default function CheckColumn({
  checked,
  children,
  icon,
  text,
  colorClass = "text-success",
  wrapped = true
}) {
  if (!checked) {
    return wrapped ? <td /> : null;
  }

  return (
    <td className={colorClass}>
      <Icon name={icon} fixed /> {text} {children}
    </td>
  );
}

CheckColumn.propTypes = {
  wrapped: T.bool,
  checked: T.bool,
  children: T.oneOfType([T.node, T.arrayOf(T.node)]),
  colorClass: T.string,
  icon: T.string.isRequired,
  text: T.string.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/DataTables/CheckColumn.jsx